import { displayLocale } from './localeState'
import english from './ui-en.json'
import followup from './ui-followup-en.json'
import finance from './finance-en.json'
import imageBatch from './image-batch-en.json'
import apiIntegration from './api-integration-en.json'

const dictionary: Record<string, string> = { ...english, ...followup, ...finance, ...imageBatch, ...apiIntegration }

// Explicit UI-only dictionary. Unknown values stay intact. Never apply this to
// business names, credentials, addresses, request payloads or stored audit text.
export function uiText(value: string | null | undefined): string {
  const text = value ?? ''
  if (displayLocale.value !== 'en-US') return text
  return Object.prototype.hasOwnProperty.call(dictionary, text) ? dictionary[text]! : text
}

/** Reviewed UI format only. Values stay literal; no substring translation or HTML. */
export function uiFormat(format: string, values: readonly unknown[]): string {
  return uiText(format).replace(/\{(\d+)\}/g, (token, index) =>
    Number(index) < values.length ? String(values[Number(index)] ?? '') : token)
}
